import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";
import type { Point } from "@/lib/geometry";
import { MEASUREMENT_GEOMETRY_TYPES as DOMAIN_MEASUREMENT_GEOMETRY_TYPES } from "@/lib/measurement-domain";
import type { MeasurementType, ToolType } from "@/viewport-tools/measurement";

export const MEASUREMENT_GEOMETRY_TYPES = DOMAIN_MEASUREMENT_GEOMETRY_TYPES;

export interface MeasurementGeometry {
  type: typeof MEASUREMENT_GEOMETRY_TYPES.rect;
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface PolygonGeometry {
  type: typeof MEASUREMENT_GEOMETRY_TYPES.poly;
  vertices: Point[];
}

export interface MeasurementAnnotation {
  textOffset?: Point;
  leaderVisible?: boolean;
  strokeWidth?: number;
}

export interface MeasurementOverlayRecord {
  _id: Id<"takeoffPilotMeasurements">;
  tagId?: Id<"takeoffPilotExtractedTags">;
  tool: ToolType;
  measurementType: MeasurementType;
  geometry: MeasurementGeometry | PolygonGeometry;
  annotation?: MeasurementAnnotation;
  height?: number;
  value: number;
}

export interface DraftMeasurementState {
  tool: ToolType;
  measurementType: MeasurementType;
  geometry: MeasurementGeometry | PolygonGeometry;
  annotation?: MeasurementAnnotation;
  height?: number;
  value: number;
  tagId?: Id<"takeoffPilotExtractedTags">;
}

export interface MeasurementTagOption {
  id: Id<"takeoffPilotExtractedTags">;
  label: string;
}

export interface MeasurementEditDraft {
  valueInput: string;
  valueChanged: boolean;
  heightInput: string;
  heightChanged: boolean;
}
